"use strict";

/**
 * @classdesc
 * Implementierung des Feature-Service zur Abfrage von HTML-Popups zu entsprechenden Features.
 *
 * @class
 * @extends gc.gis.service.AbstractFeatureService
 * @memberof gc.gis.service
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {gc.gis.util.GCRequestManager} requestManager Objekt zur Ausführung von Requests
 * @param {string} popupUrl Service-URL zum Identifizieren von Objekten
 */
gc.gis.service.HtmlPopupService = function(requestManager, popupUrl)
{
	gc.gis.service.AbstractFeatureService.call(this, requestManager);

	/**
	 * @type {string}
	 * @private
	 */
	this._popupUrl = popupUrl;
	/**
	 * @type {jqXHR|undefined}
	 * @private
	 */
	this._lastRequest = undefined;
};
gc.gis.service.HtmlPopupService.prototype = Object.create(gc.gis.service.AbstractFeatureService.prototype);


/**
 * Führt eine Identifizieren-Abfrage durch.
 *
 * @param {gc.gis.layer.GCLayer[]} layers die abzufragenden Layer
 * @param {gc.gis.geom.GCPoint} point Abfragegeometrie
 * @param {gc.gis.map.GCMapExtent} map_extent Kartenausdehnung
 * @param {gc.gis.map.GCMapSize} map_size Kartengröße
 */
gc.gis.service.HtmlPopupService.prototype.htmlPopup = function (layers, point, map_extent, map_size)
{
	if (layers.length === 0)
	{
		return;
	}

	var self = this,
		layersNames = [];

	layers.forEach(function (lyr) {
		if (lyr instanceof gc.gis.layer.GCLayer)
		{
			layersNames.push(lyr.getName());
		}
	});

	this.cancelCurrentRequest();

	this._lastRequest = this._requestManager.ajax({
		url: self._popupUrl,
		data: {
			x: point.getX(),
			y: point.getY(),
			crs: point.getCRS(),
			layers: layersNames.join(','),
			mapExtent: map_extent.join(','),
			mapSize: map_size.join(',')
		},
		label: 'Lade Tooltip',
		silent: true,
		abortSilent: true,
		start: function() {
			self._fireEvent(gc.gis.service.FeatureServiceEvent.HTML_POPUP_START, {
				layers: layers
			});
		},
		success: function(data) {

			self._fireEvent(gc.gis.service.FeatureServiceEvent.HTML_POPUP_SUCCESS, {
				layers: layers,
				htmlPopup: data.content
			});
		},
		error: function(err) {
			self._fireEvent(gc.gis.service.FeatureServiceEvent.HTML_POPUP_ERROR, {
				layers: layers,
				error: err
			});
		},
		finally: function () {
			self._lastRequest = undefined;
		}
	});
};

/**
 * Bricht den akuellen Request zum Laden des Tooltips ab.
 */
gc.gis.service.HtmlPopupService.prototype.cancelCurrentRequest = function()
{
	if (this._lastRequest)
	{
		this._requestManager.abort(this._lastRequest);
		this._lastRequest = undefined;
	}
};